import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import Paper from '@/components/Paper'
import type { CustomerContract } from '@/modules/Contract/types'
import { useContractList } from '@/modules/Contract/hooks/use-contract-list'

const List = () => {
    const {
        contracts,
        pagination,
        stateComponent,
        isFetching,
        params,
        control,
        searchInputProps,
        columns,
        actions,
        expandable,
        filterItems,
        setFilter,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
    } = useContractList()

    return (
        <Paper className="mt-2">
            <FilterBar
                control={control}
                setFilter={setFilter}
                items={filterItems}
                hideSearch
            />
            {stateComponent || (
                <DataTableCustomized<CustomerContract>
                    columns={columns}
                    rows={contracts}
                    rowKey={(row) => row.contract_id}
                    size="small"
                    resizable
                    isFetching={isFetching}
                    actions={actions}
                    expandable={expandable}
                    toolbar={{
                        search: searchInputProps,
                        settings: {
                            show: true,
                            storageKey: 'contract-customers-list',
                        },
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                    stickyHeader={{
                        enabled: true,
                        offsetTopSelector: '#main-header',
                    }}
                />
            )}
        </Paper>
    )
}

export default List
